import React from 'react';

//images
import facebook from '../img/facebook.png';
import github from '../img/github.png';
import gmail from '../img/gmail.png';

//importing links
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<div className="social-media">
			<Link
				to={{ pathname: 'https://www.facebook.com/jivan.parajuli/' }}
				target="_blank"
			>
				<img width="20px" src={facebook} alt="facebook" />
			</Link>
			<Link to={{ pathname: 'https://github.com/LikheKeto' }} target="_blank">
				<img width="20px" src={github} alt="github" />
			</Link>
			<Link
				to={{ pathname: 'mailto:jivanparajuli26@gmail.com' }}
				target="_blank"
			>
				<img width="20px" src={gmail} alt="gmail" />
			</Link>
		</div>
	);
};

export default Footer;
